import { render, staticRenderFns } from "./OvbKedvezmenyekB3.vue?vue&type=template&id=f663f220&"
import script from "./OvbKedvezmenyekB3.vue?vue&type=script&lang=js&"
export * from "./OvbKedvezmenyekB3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports